import {initLocalStorage} from '../../js/util/LocalStorage'
import {initStore} from '../../js/redux/store'
import createRootReducer from './reducer'
import $ from '../../js/alias/jquery'
import LicenseCountDownTip from '../../js/activeLicenseInfo/LicenseCountDownTip'
import ContactSupportDraggablePopupContainer from '../../js/support/supportForm/ContactSupportDraggablePopupContainer'
import {clearSupportPopupInfoInLocalStorage as clearSupportPopupInfo, getSupportPopupInfoFromLocalStorage} from '../../js/support/supportForm/utils'
import SupportQuestionButton from '../../js/support/supportForm/SupportQuestionButton'
import WelcomeScreenContainer from '../../js/support/welcomeScreen/WelcomeScreenContainer'
import {getICalInfoFromLocalStorage} from './icalendar/utils'
import AddonsMenuContainer from './addons/AddonsMenuContainer'
import ToastsContainer from '../../js/toasts/components/ToastsContainer'

export default function initApplication() {
    const INIT_DATA = window.__INIT_APP_DATA__

    // load data from local storage
    initLocalStorage(INIT_DATA.LOGGED_IN_USER.id)

    if (window.__IS_FIRST_SCREEN_AFTER_LOGIN__) {
        cleanupLocalStorageForNewSession()
    }

    INIT_DATA.SUPPORT = {
        ...INIT_DATA.SUPPORT,
        POPUP_INFO: {
            ...getSupportPopupInfoFromLocalStorage(),
        },
    }

    INIT_DATA.ICALENDAR = {
        ...INIT_DATA.ICALENDAR,
        ICAL_INFO: {
            ...getICalInfoFromLocalStorage()
        }
    }

    initStore(INIT_DATA, createRootReducer)

    initCommonComponents(INIT_DATA)
}

function initCommonComponents(INIT_DATA) {
    const $body = $('body')
    new LicenseCountDownTip().init($body)
    new ToastsContainer().init($body)
    new SupportQuestionButton().init($('.contactSupportButtonPlaceholder'))
    new ContactSupportDraggablePopupContainer().init()
    new AddonsMenuContainer().init()

    if (INIT_DATA.WELCOME.showWelcomeScreen) {
        new WelcomeScreenContainer().init()
    }
}

function cleanupLocalStorageForNewSession() {
    clearSupportPopupInfo()
}



// WEBPACK FOOTER //
// ./web/actiplans/js/initApplication.js